import { Injectable } from '@angular/core';
import { ApiResponse } from 'src/models/api-response.model';
import { Subject, Observable, lastValueFrom, async } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiConstants } from '../constants/api-constants';

@Injectable({
  providedIn: 'root'
})
export class WidgetService {
  layoutChanged = new Subject<boolean>();
  widgetAdded = new Subject<any>();
  gridLocked = new Subject<boolean>();
  privacyMode = new Subject<boolean>();
  userLayouts: any[] = [];

  availableWidgets: any[] = [];

  constructor(private http: HttpClient) { }

  layoutChangedListener() {
    return this.layoutChanged.asObservable();
  }

  widgetAddedListener() {
    return this.widgetAdded.asObservable();
  }

  addWidget(widget: any) {
    this.widgetAdded.next(widget);
  }

  gridLockedListener() {
    return this.gridLocked.asObservable();
  }

  privacyModeListener() {
    return this.privacyMode.asObservable();
  }

  async modifyDefaultLayout(layout: any) {
    const requestBody = { layout: layout };
    let URL = ApiConstants.URL_LAYOUT + '/default';
    let res = await lastValueFrom(this.http.put<ApiResponse>(URL, requestBody));
    return res;
  }

  async createLayout(name: string, layout: any) {
    const requestBody = {
      name: name,
      layout: JSON.parse(layout)
    };
    let URL = ApiConstants.URL_USER_LAYOUTS;
    let res = await lastValueFrom(
      this.http.post<ApiResponse>(URL, requestBody)
    );
    return res;
  }

  async resetToDefault() {
    let URL = ApiConstants.URL_USER_LAYOUTS + '/reset';
    let res = await lastValueFrom(this.http.post<ApiResponse>(URL, null));
    return res;
  }

  async getUserLayouts() {
    let URL = ApiConstants.URL_USER_LAYOUTS;
    let res = await lastValueFrom(this.http.get<ApiResponse>(URL));
    this.userLayouts = res?.success && res?.data ? res.data : [];
    return this.userLayouts;
  }

  async getActiveLayout() {
    let URL = ApiConstants.URL_USER_LAYOUTS + '/active';
    let res = await lastValueFrom(this.http.get<ApiResponse>(URL));
    return res?.success && res?.data ? res.data : [];
  }

  async setActiveLayout(layoutId: number) {
    let URL = ApiConstants.URL_USER_LAYOUTS + '/' + layoutId + '/activate';
    let res = await lastValueFrom(this.http.patch<ApiResponse>(URL, null));
    return res;
  }

  async updateLayout(layoutId: number, name: string, layout: any) {
    let URL = ApiConstants.URL_USER_LAYOUTS + '/' + layoutId;
    const requestBody = {
      layout: layout,
      name: name
    };
    let res = await lastValueFrom(this.http.put<ApiResponse>(URL, requestBody));
    return res;
  }

  async deleteLayout(layoutId: number) {
    let URL = ApiConstants.URL_USER_LAYOUTS + '/' + layoutId;
    let res = await lastValueFrom(this.http.delete<ApiResponse>(URL));
    return res;
  }

  async getWidgets() {
    let URL = ApiConstants.URL_LAYOUT + '/widgets';
    let res = await lastValueFrom(this.http.get<ApiResponse>(URL));
    return res?.success && res?.data ? res.data : [];
  }

  get currentlyUiActiveLayout() {
    return this.userLayouts?.find(layout => layout.isActive);
  }
}
